import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useOffer } from '../api/offers';
import { Header } from '../components/layout/Header';
import { FiAlertCircle } from 'react-icons/fi';
import { Button } from '../components/ui/Button';

export const Route = createFileRoute('/offers/$offerId/chat')({
  component: OfferChatRedirectPage,
});

function OfferChatRedirectPage() {
  const { offerId } = Route.useParams();
  const navigate = useNavigate();
  const { data: offer, isLoading, isError } = useOffer(offerId);

  useEffect(() => {
    if (!offer) return;

    if (offer.conversationId) {
      navigate({
        to: '/messages',
        search: {
          conversationUuid: offer.conversationId,
          offerUuid: offer.id,
        },
        replace: true,
      });
      return;
    }

    // Direct offer or offer without chat conversation: route to offer details view
    navigate({
      to: '/offers/$offerId',
      params: { offerId },
      replace: true,
    });
  }, [offer, offerId, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black text-white pb-28">
        <Header />
        <main className="mx-auto max-w-[1360px] px-4 sm:px-6 lg:px-8 pt-[calc(var(--header-height,5.5rem)+1.75rem)] flex flex-col items-center justify-center min-h-[50vh] text-center">
          <p className="text-sm text-zinc-400">Opening offer in chat…</p>
        </main>
      </div>
    );
  }

  if (isError || !offer) {
    return (
      <div className="min-h-screen bg-black text-white pb-28">
        <Header />
        <main className="mx-auto max-w-[1360px] px-4 sm:px-6 lg:px-8 pt-[calc(var(--header-height,5.5rem)+1.75rem)] flex flex-col items-center justify-center min-h-[50vh] text-center">
          <FiAlertCircle size={48} className="text-zinc-600 mb-4" />
          <h2 className="text-xl font-bold text-white mb-2">Offer not found</h2>
          <p className="text-sm text-zinc-400 mb-6">
            The requested offer could not be found or has expired.
          </p>
          <Button
            onClick={() => navigate({ to: '/profile/my-gigs', search: { tab: 'offers' } })}
            size="lg"
            className="rounded-full px-8"
          >
            Back to My Gigs
          </Button>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white pb-28">
      <Header />
      <main className="mx-auto max-w-[1360px] px-4 sm:px-6 lg:px-8 pt-[calc(var(--header-height,5.5rem)+1.75rem)]">
        <p className="text-sm text-zinc-400">Redirecting to chat…</p>
      </main>
    </div>
  );
}
